import { Injectable } from '@angular/core';
import xss from 'xss';

@Injectable({
  providedIn: 'root',
})
export class DataSanitizerService {
  SKIP = 'SKIP-sanitization';

  // The `any` type is used here to handle diverse data structures.
  sanitizeData(data: any): any {
    // Return null or undefined as it is.
    if (!data) {
      return data;
    }
    // If data is an array, sanitize each item in the array
    if (Array.isArray(data)) {
      return data.map((item) => this.sanitizeData(item));
    }
    // If data is an object, recursively sanitize each property
    if (typeof data === 'object') {
      const sanitizedData: Record<string, any> = {};
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          sanitizedData[key] = this.sanitizeData(data[key]);
        }
      }
      return sanitizedData;
    }

    if (typeof data === 'string') {
      return this.sanitizeString(data);
    }
    // Return other types as they are (e.g., numbers, booleans)
    return data;
  }

  private sanitizeString(value: string) {
    return xss(value);
  }
}
